import { ASSET_VERSION_QUERY } from './assetVersionQuery';
const pathDefaultAndroid = 'https://play.google.com/store/apps/details?id=';
const pathDefaultIOS = 'https://apps.apple.com/it/app/';
export const BRAND_DOMAINS = [
    { domain: '.vianova.it',
        brand: 'vianova',
        color: '#ff4600',
        font: 'Roboto, sans-serif',
        favicon: '/images/favicon-vianova.ico',
        pathIOS: pathDefaultIOS + 'id1507145324',
        pathAndroid: pathDefaultAndroid + 'it.vianova.meet',
        imageInRoom: `images/watermark-vianova.png${ASSET_VERSION_QUERY}`,
        pathPasswordRecovery: 'https://areaclienti.vianova.it/#passwordRecovery',
        supportUrl: 'https://vianova.it/',
        serviceName: 'Vianova Meeting',
        infoUrl: 'https://www.vianova.it/supporto/meeting/panoramica/',
        privacyUrl: '{hostname}/note-legali/index.html#privacy',
        cookieUrl: 'https://www.vianova.it/cookie-policy/',
        termsUrl: '{hostname}/note-legali/index.html#termini',
        logoFilename: 'logoVianova.svg' },
    { domain: '.kalliope.cloud',
        brand: 'kalliope',
        color: '#f98815',
        font: 'Poppins, sans-serif',
        favicon: '/images/favicon-kalliope.ico',
        pathIOS: pathDefaultIOS + 'id6749302594',
        pathAndroid: pathDefaultAndroid + 'it.kalliope.meet',
        imageInRoom: `images/watermark-kalliope.png${ASSET_VERSION_QUERY}`,
        pathPasswordRecovery: 'https://accounts.kalliope.cloud/forgot-password',
        supportUrl: 'https://kalliope.com/',
        serviceName: 'Kalliope Meeting',
        infoUrl: 'https://www.kalliope.com/meeting',
        privacyUrl: 'https://www.kalliope.com/meeting/#privacy-policy',
        cookieUrl: 'https://www.kalliope.com/meeting/#cookie-policy',
        termsUrl: 'https://www.kalliope.com/meeting/#termini-di-utilizzo',
        logoFilename: 'logoKalliope.svg' },
    { domain: '.xstream.it',
        brand: 'xstream',
        color: '#3F57A2',
        font: 'Poppins, sans-serif',
        favicon: '/images/favicon-xstream.ico',
        pathIOS: pathDefaultIOS + 'id6755876506',
        pathAndroid: pathDefaultAndroid + 'it.xstream.meet',
        imageInRoom: `images/watermark-xstream.png${ASSET_VERSION_QUERY}`,
        pathPasswordRecovery: 'https://hermesaccount.xstream.it/forgot-password',
        supportUrl: 'https://x-stream.biz/',
        serviceName: 'Hermes Meeting',
        infoUrl: 'https://x-stream.biz/privacypolicy/',
        privacyUrl: 'https://x-stream.biz/privacypolicy/',
        cookieUrl: 'https://x-stream.biz/privacypolicy/',
        termsUrl: 'https://x-stream.biz/privacypolicy/',
        logoFilename: 'logoXstream.svg' },
    { domain: '.vivavox.it',
        brand: 'vivavox',
        color: '#43465a',
        font: 'Poppins, sans-serif',
        favicon: '/images/favicon-vivavox.ico',
        pathIOS: pathDefaultIOS + 'id6756778193',
        pathAndroid: pathDefaultAndroid + 'it.vivavox.meet',
        imageInRoom: `images/watermark-vivavox.png${ASSET_VERSION_QUERY}`,
        pathPasswordRecovery: 'https://accounts.vivavox.it/forgot-password',
        supportUrl: 'https://vivavox.it/',
        serviceName: 'VivaVox Meeting',
        infoUrl: 'https://www.vivavox.it/meeting',
        privacyUrl: 'https://www.vivavox.it/privacy-policy',
        cookieUrl: 'https://www.vivavox.it/privacy-policy',
        termsUrl: 'https://www.vivavox.it/privacy-policy',
        logoFilename: 'logoVivavox.svg' },
    { domain: '.unica.cloud',
        brand: 'unica',
        color: '#0000f4',
        font: 'Poppins, sans-serif',
        favicon: '/images/favicon-unica.ico',
        pathIOS: pathDefaultIOS + 'id6762615552',
        pathAndroid: pathDefaultAndroid + 'it.unica.meet',
        imageInRoom: `images/watermark-unica.png${ASSET_VERSION_QUERY}`,
        pathPasswordRecovery: 'https://accounts.unica.cloud/forgot-password',
        supportUrl: 'https://www.unicatlc.it',
        serviceName: 'JoinMeet',
        infoUrl: 'https://www.unicatlc.it/joinmeet',
        privacyUrl: 'https://www.unicatlc.it/privacy-policy/',
        cookieUrl: 'https://www.unicatlc.it/cookie-policy/',
        termsUrl: 'https://www.unicatlc.it/joinmeet-termini-di-utilizzo/',
        logoFilename: 'logoUnica.svg' },
    { domain: '.timenet.it',
        brand: 'timenet',
        color: '#25a1c3',
        font: 'Poppins, sans-serif',
        favicon: '/images/favicon-timenet.ico',
        pathIOS: pathDefaultIOS + 'id6763513776',
        pathAndroid: pathDefaultAndroid + 'it.timenet.meet',
        imageInRoom: `images/watermark-timenet.png${ASSET_VERSION_QUERY}`,
        pathPasswordRecovery: 'https://accounts.timenet.it/forgot-password',
        supportUrl: 'https://timenet.it/',
        serviceName: 'Losiria Meeting',
        infoUrl: 'https://www.losiria.it/losiria-meeting',
        privacyUrl: 'https://www.losiria.it/privacy-policy',
        cookieUrl: 'https://www.losiria.it/privacy-policy',
        termsUrl: 'https://www.losiria.it/privacy-policy',
        logoFilename: 'logoTimenet.svg' },
];
export function getBrand(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.brand : '';
}
export function getBrandColor(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.color : '#000000';
}
export function getBrandFont(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.font : 'Roboto, sans-serif';
}
export function getBrandFavicon(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.favicon : '/images/favicon-vianova.ico';
}
export function getBrandPathIOS(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.pathIOS : '';
}
export function getBrandPathAndroid(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.pathAndroid : '';
}
export function getBrandImageInRoom(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.imageInRoom : `images/watermark-vianova.png${ASSET_VERSION_QUERY}`;
}
export function getBrandPasswordRecoveryPath(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.pathPasswordRecovery : undefined;
}
export function getBrandSupportUrl(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.supportUrl : 'https://vianova.it/';
}
export function getBrandServiceName(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.serviceName : 'Vianova';
}
function replaceDynamicUrl(urlPattern) {
    if (urlPattern.includes('{hostname}')) {
        return urlPattern.replace('{hostname}', 'https://' + window.location.hostname);
    }
    return urlPattern;
}
export function getBrandInfoUrl(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? replaceDynamicUrl(match.infoUrl) : 'https://www.vianova.it/supporto/meeting/panoramica/';
}
export function getBrandPrivacyUrl(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? replaceDynamicUrl(match.privacyUrl) : 'https://www.vianova.it/cookie-policy/';
}
export function getBrandCookieUrl(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? replaceDynamicUrl(match.cookieUrl) : 'https://www.vianova.it/cookie-policy/';
}
export function getBrandTermsUrl(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? replaceDynamicUrl(match.termsUrl) : replaceDynamicUrl('{hostname}/note-legali/index.html#termini');
}
export function getBrandLogoFilename(url = window.location.href) {
    const match = BRAND_DOMAINS.find(entry => url.includes(entry.domain));
    return match ? match.logoFilename : 'logoVianova.svg';
}
